import { useState } from 'react'
import api from '../services/api'
import {
  Button,
  Container,
  Box,
  Slider,
  Typography,
  Paper,
  TextField
} from '@mui/material'
import { useSearchParams, useNavigate } from 'react-router-dom'

export default function CreateFeedback() {
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const [questionOne, setOne] = useState(3)
  const [questionTwo, setTwo] = useState(3)
  const [questionThree, setThree] = useState(3)
  const [questionFour, setFour] = useState(3)
  const [suggestion, setSuggestion] = useState('#')

  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleSubmit = async (event) => {
    event.preventDefault()
    setIsSubmitting(true)
    await api
      .post('/feedback', {
        origin:
          searchParams.get('origin') === null
            ? 'none'
            : searchParams.get('origin'),
        q_one: questionOne,
        q_two: questionTwo,
        q_three: questionThree,
        q_four: questionFour,
        suggestion: suggestion
      })
      .then(() => {
        navigate(
          searchParams.get('name') === null
            ? '/success'
            : `/success?name=${searchParams.get('name')}`
        )
      })
      .catch((err) => {
        console.log(err)
      })
      .finally(() => setIsSubmitting(false))
  }

  const emojis = ['😢', '😐', '🙂', '😁', '❤️']

  const questions = [
    [
      questionOne,
      setOne,
      `How do you rate MatchUp's support during the campaign?`,
      `How do you rate MatchUp's Manager approach during the campaign?`
    ],
    [
      questionTwo,
      setTwo,
      `What did you think of working with ${
        searchParams.get('brand') || 'us'
      }?`,
      `Did the Campaign meet your expectations?`
    ],
    [
      questionThree,
      setThree,
      `Would you like to work with MatchUp again?`,
      `What did you think about the chosen Influencers?`
    ],
    [
      questionFour,
      setFour,
      `Would you recommend MatchUp to other influencers?`,
      `Would you work with MatchUp again?`
    ]
  ]

  return (
    <Container
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        my: 4
      }}
    >
      <img width="150px" src="img/mp.png" alt="logo" />
      <Box
        sx={{
          width: 360,
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center'
        }}
      >
        {questions.map((item) => (
          <Paper
            sx={{ px: 4, py: 2, mb: 0, mt: 2, width: '100%', borderRadius: 6 }}
          >
            <Typography align="center" sx={{ px: 4 }}>
              {searchParams.get('origin') === 'client' ? item[3] : item[2]}
            </Typography>
            <Typography
              variant="h4"
              align="center"
              sx={{
                position: 'relative',
                left: (item[0] - 3) * 74,
                transition: '100ms'
              }}
            >
              {emojis[item[0] - 1]}
            </Typography>
            <Slider
              onChange={(event) => item[1](event.target.value)}
              defaultValue={3}
              min={1}
              max={5}
            />
          </Paper>
        ))}
        <Paper
          sx={{ px: 4, pt: 2, pb: 3, my: 2, width: '100%', borderRadius: 6 }}
        >
          <Typography align="center">
            {searchParams.get('origin') === 'client'
              ? `Comment below your experience. Was it good? Could we do something better?`
              : `Comment in a tweet about your experience. Was it good? Could we do
              something better?`}
          </Typography>
          <TextField
            onChange={(event) => setSuggestion(event.target.value)}
            fullWidth
            multiline={true}
            sx={{ mt: 2 }}
          />
        </Paper>
      </Box>
      <Button
        variant="contained"
        onClick={handleSubmit}
        sx={{ fontWeight: 900, borderRadius: 2 }}
        size="large"
        disabled={isSubmitting}
      >
        {isSubmitting ? 'SENDING' : 'SEND'}
      </Button>
    </Container>
  )
}
